import client from './client';

import { getApiBaseUrl } from '../config/env';

const BASE_URL = getApiBaseUrl();

function recruiterHeaders() {
  const recruiterToken = window.localStorage.getItem('recruiter_token');
  const headers = { 'Content-Type': 'application/json' };
  if (recruiterToken) {
    headers.Authorization = `Bearer ${recruiterToken}`;
  }
  return headers;
}

/**
 * Search opted-in talent profiles (public endpoint).
 */
export async function searchTalent(params = {}) {
  const { data } = await client.get('/api/talent/search', { params });
  return Array.isArray(data) ? data : [];
}

/** Pool stats for hero bar (public). */
export async function fetchTalentStats() {
  const { data } = await client.get('/api/talent/stats');
  return data;
}

/** Current recruiter profile + credits (requires recruiter JWT). */
export async function fetchRecruiterMe() {
  const res = await fetch(`${BASE_URL}/api/talent/recruiter/me`, {
    headers: recruiterHeaders(),
  });
  if (!res.ok) {
    const err = new Error(`Failed to load recruiter profile (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}

/**
 * Unlock candidate contact (recruiter auth required).
 */
export async function unlockCandidateContact(profileId) {
  const res = await fetch(`${BASE_URL}/api/talent/recruiter/contact/${profileId}`, {
    method: 'POST',
    headers: recruiterHeaders(),
    credentials: 'include',
  });

  if (res.status === 401) {
    const err = new Error('Sign in required to unlock contact details.');
    err.status = 401;
    throw err;
  }

  if (!res.ok) {
    let message = `Request failed (${res.status})`;
    try {
      const body = await res.json();
      message = body.message || body.error || message;
    } catch {
      /* ignore */
    }
    const err = new Error(message);
    err.status = res.status;
    throw err;
  }

  return res.json();
}
